import React, { useState, useEffect } from 'react';
import Styles from './SeguroAuto25Condicoes.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import clsx from 'clsx';
import ModalSeguros from '@/components/molecules/ModalSeguros';
const Tabs = {
  SantanderAuto: 0,
  Zurich: 1,
};
function SeguroAuto25Condicoes() {
  const [activeTab, setActiveTab] = useState(Tabs['SantanderAuto']);

  const [showModalSantander, setShowModalSantander] = useState(false);
  const tituloModalSantander = 'Condições Contratuais: Santander Auto';
  const docsSantander = [
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 03/11/2022 a 26/10/2023`,
      link: 'assets/seguro/pdf/03-11-22-em-diante.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 26/08/2021 a 02/11/2022`,
      link: 'assets/seguro/pdf/26-08-21-em-diante.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 11/06/2021 a 25/08/2021`,
      link: 'assets/seguro/pdf/cg-santander-auto-11-06-2021-a-25-08-2021.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 16/03/2021 a 10/06/2021`,
      link: 'assets/seguro/pdf/cg-santander-auto-16-03-2021-a-10-06-2021.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 25/09/2020 a 15/03/2021`,
      link: 'assets/seguro/pdf/cg-santander-auto-25-09-2020-a-15-03-2021.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 12/08/2020 a 24/09/2020`,
      link: 'assets/seguro/pdf/cg-santander-auto-12-08-2020-a-24-09-2020.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 21/07/2020 a 11/08/2020`,
      link: 'assets/seguro/pdf/cg-santander-auto-21-07-2020-a-11-08-2020.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 05/05/2020 a 20/07/2020`,
      link: 'assets/seguro/pdf/cg-santander-auto-05-05-2020-a-20-07-2020.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 23/11/2019 a 04/05/2020`,
      link: 'assets/seguro/pdf/cg-santander-auto-23-11-2019-a-04-05-2020.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 09/08/2019 a 22/11/2019`,
      link: 'assets/seguro/pdf/cg-santander-auto-09-08-2019-a-22-11-2019.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 05/07/2019 a 08/08/2019`,
      link: 'assets/seguro/pdf/cg-santander-auto-05-07-2019-a-08-08-2019.pdf',
    },
    {
      titulo: 'Condições Contratuais: Santander Auto',
      descricao: `Vigência: de 21/06/2019 a 04/07/2019`,
      link: 'assets/seguro/pdf/cg-santander-auto-21-06-2019-a-04-07-2019.pdf',
    },
  ];

  const [showModalZurich, setShowModalZurich] = useState(false);
  const tituloModalZurich = 'Condições Contratuais: Zurich';
  const docsZurich = [
    {
      titulo: 'Condições Contratuais: Zurich',
      descricao: `Vigência: de 23/09/2020 até 19/01/2021`,
      link: 'pdf/protegido/15414.901791_2019-11 CGs_NV_Prestamista v3.pdf',
    },
    {
      titulo: 'Condições Contratuais: Zurich',
      descricao: `Vigência: de 27/06/2020 até 22/09/2020`,
      link: 'pdf/protegido/15414.901791_2019-11 CGs_NV_Prestamista_v2.pdf',
    },
    {
      titulo: 'Condições Contratuais: Zurich',
      descricao: `Vigência: de 30/09/2019 até 26/06/2020`,
      link: 'pdf/protegido/CGs_NV_Prestamista_v1.pdf',
    },
    {
      titulo: 'Condições Contratuais: Zurich',
      descricao: `Vigência: até 29/09/2019 `,
      link: 'pdf/protegido/CG-Prestamista-CDC-Protegido-Out19.pdf',
    },
  ];

  useEffect(() => {
    if (showModalSantander) {
      document.getElementsByTagName('html')[0].classList.add('scroll-disabled');
    } else {
      document.getElementsByTagName('html')[0].classList.remove('scroll-disabled');
    }
  }, [showModalSantander]);

  useEffect(() => {
    if (showModalZurich) {
      document.getElementsByTagName('html')[0].classList.add('scroll-disabled');
    } else {
      document.getElementsByTagName('html')[0].classList.remove('scroll-disabled');
    }
  }, [showModalZurich]);

  return (
    <>
      <section id="seguro-auto-condicoes">
        <div className="condicoes-tabs">
          <button
            id="tab-santander-auto"
            onClick={() => {
              setActiveTab(Tabs['SantanderAuto']);
            }}
            className={activeTab === Tabs['SantanderAuto'] && 'active'}
          >
            Santander auto
          </button>
          <button
            id="tab-zurich"
            onClick={() => {
              setActiveTab(Tabs['Zurich']);
            }}
            className={activeTab === Tabs['Zurich'] && 'active'}
          >
            Zurich
          </button>
        </div>
        <ContainerHome24>
          <div className="condicoes-contain">
            <img src="assets/seguro-auto-25/carros.svg" alt="" className="condicoes-contain-img" />
            <div className="condicoes-contain-conteudo">
              <h2 className="condicoes-contain-titulo">Conheça nossas condições contratuais</h2>
              <div
                className={clsx(
                  'tab-santander-auto-condicoes',
                  activeTab === Tabs['SantanderAuto'] && 'active',
                )}
              >
                <div className="cards-condicao">
                  <a
                    href="assets/seguro/pdf/14-11-25-em-diante.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Contratuais: Santander Auto
                      </h3>
                      <p className="condicao-textos-descricao">Vigência: de 14/11/2025 em diante</p>
                    </div>
                  </a>
                  <a
                    href="assets/seguro/pdf/21-01-25-em-diante.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Contratuais: Santander Auto
                      </h3>
                      <p className="condicao-textos-descricao">
                        Vigência: de 21/01/2025 a 13/11/2025
                      </p>
                    </div>
                  </a>
                  <a
                    href="assets/seguro/pdf/27-10-23-em-diante.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Contratuais: Santander Auto
                      </h3>
                      <p className="condicao-textos-descricao">
                        Vigência: de 27/10/2023 a 20/01/2025
                      </p>
                    </div>
                  </a>
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    setShowModalSantander(true);
                  }}
                  className="link-condicoes-antigas"
                >
                  Exibir condições mais antigas
                </div>
              </div>
              <div
                className={clsx('tab-zurich-condicoes', activeTab === Tabs['Zurich'] && 'active')}
              >
                <div className="cards-condicao">
                  <a
                    href="pdf/seguro-auto/condicoes-zurich/manual-do-cliente-automovel-assistencia-24-horas-versao-janeiro-2024.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">Condições Contratuais: Zurich</h3>
                      <p className="condicao-textos-descricao">
                        Vigência: de Janeiro/2024 em diante
                      </p>
                    </div>
                  </a>
                  <a
                    href="pdf/seguro-auto/condicoes-zurich/manual-do-segurado-zurich-automovel-versao-setembro-2023.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">Condições Contratuais: Zurich</h3>
                      <p className="condicao-textos-descricao">
                        Vigência: de Setembro/2023 até Dezembro/2023
                      </p>
                    </div>
                  </a>
                  {/* <a href="" target="_blank" className="card-condicao">
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">Condições Contratuais: Zurich</h3>
                      <p className="condicao-textos-descricao">Vigência: de 27/10/2023 em diante</p>
                    </div>
                  </a> */}
                </div>
                {/* <div
                  onClick={(e) => {
                    e.preventDefault();
                    setShowModalZurich(true);
                  }}
                  className="link-condicoes-antigas"
                >
                  Exibir condições mais antigas
                </div> */}
              </div>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <section id="seguro-auto-garantido">
        <ContainerHome24>
          <p className="seguro-auto-garantido-texto">
            Seguro garantido pela Santander Auto S.A. CNPJ 30.617.319/0001-21– Código SUSEP: 01589,
            Processo SUSEP Nº 15414.901483/2019-95. O registro do produto é automático e não
            representa aprovação ou recomendação por parte da Susep. Saiba mais em:
            www.santanderauto.com.br. Central de atendimento Santander Auto e SAC: 0800 201 9500.
            Deficiente Auditivo: 0800 201 9002. Ouvidoria: 0800 201 9700.
          </p>
        </ContainerHome24>
      </section>
      {showModalSantander && (
        <ModalSeguros
          setShowModal={setShowModalSantander}
          tituloModal={tituloModalSantander}
          docs={docsSantander}
        />
      )}
      {showModalZurich && (
        <ModalSeguros
          setShowModal={setShowModalZurich}
          tituloModal={tituloModalZurich}
          docs={docsZurich}
        />
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

export default SeguroAuto25Condicoes;
